import { render, staticRenderFns } from "./AuthenticateForgotten.vue?vue&type=template&id=ce2191c2&scoped=true&"
import script from "./AuthenticateForgotten.vue?vue&type=script&lang=js&"
export * from "./AuthenticateForgotten.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticateForgotten.vue?vue&type=style&index=0&id=ce2191c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2191c2",
  null
  
)

export default component.exports